import api from './api';

export const loyaltyService = {
  // Récupère les paramètres de fidélité (publique)
  getSettings: async () => {
    const response = await api.get('/api/loyalty/settings');
    return response.data;
  },

  // Récupère tous les paramètres (admin)
  getAllSettings: async () => {
    const response = await api.get('/api/loyalty/admin/settings');
    return response.data;
  },

  // Met à jour un paramètre
  updateSetting: async (key, value) => {
    const response = await api.put('/api/loyalty/admin/settings', { key, value });
    return response.data;
  },

  // Calcule la conversion de points
  calculateConversion: async (orderTotal) => {
    const response = await api.post('/api/loyalty/calculate-conversion', { orderTotal });
    return response.data;
  },

  // Valide l'utilisation de points
  validatePointsUsage: async (pointsToUse, orderTotal) => {
    const response = await api.post('/api/loyalty/validate-points', {
      pointsToUse,
      orderTotal,
    });
    return response.data;
  },
};

